import styled from "styled-components";
import Icon from "../Icon";
import { Container } from "../styled/Container";
import { Paragraph } from "../styled/Text";
import { HyperLink } from "../styled/Link";
const FooterWrapper = styled(Container)`
  display: flex;
  align-items: center;
  width: 100%;
  align-items: baseline;
  border-top: 3px dotted #000;
`;

const FooterContainer = styled.div`
  display: flex;
  padding: 0px;
  margin-top: 25px;
  margin-bottom: 50px;
  justify-content: space-between;
  width: 100%;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 25px;
    padding-left: 24px;
    padding-right: 24px;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const FlexContainerRight = styled(FlexContainer)`
  justify-content: center;
  gap: 30px;

  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FlexContainer>
          <Paragraph marginRight="20px">© Lossless</Paragraph>
          <HyperLink
            href="https://lossless.io/terms-of-use/"
            rel="noreferrer"
            target="_blank"
          >
            Terms and Conditions
          </HyperLink>
          <HyperLink
            href="https://lossless.io/privacy-policy/"
            rel="noreferrer"
            target="_blank"
          >
            Privacy Policy
          </HyperLink>
        </FlexContainer>
        <FlexContainerRight>
          <HyperLink
            href="https://losslesscash.medium.com/"
            rel="noreferrer"
            target="_blank"
          >
            <Icon name="medium" width={20} height={20} />
          </HyperLink>
          <HyperLink
            href="https://twitter.com/losslessdefi"
            rel="noreferrer"
            target="_blank"
          >
            <Icon name="twitter" width={20} height={20} />
          </HyperLink>
          <HyperLink
            href="https://discord.com/invite/5kruscwkJY"
            rel="noreferrer"
            target="_blank"
          >
            <Icon name="discord" width={20} height={20} />
          </HyperLink>
          <HyperLink
            href="https://t.me/losslesscash"
            rel="noreferrer"
            target="_blank"
          >
            <Icon name="telegram" width={20} height={20} />
          </HyperLink>
        </FlexContainerRight>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
